import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import axios from "axios";
import DataTable from "react-data-table-component";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CustomPagination from "./../../cm_shared/CMCustomPagination";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import DescriptionIcon from "@material-ui/icons/Description";
import { containsFctwPattern } from "../../../../helper"
import { LoadingContext } from "./../../../../context/spinnerContext"

const customStyles = {
  table: {
    style: {
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};
function TestRunsListing(props) {
  console.log('props', props);
  const { setIsLoading } = useContext(LoadingContext); 
  
  const [loadingOverlay, setLoadingOverlay] = useState(false);

  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const handleChange = async (event) => {
    const newRow = event.selectedRows;
    if (scenarioCollectionNew.length === newRow.length || event.allSelected) {
      props.onSelectAllRow(newRow, selectedRows);
    } else if (newRow.length === 0 && !event.allSelected) {
      props.onDeselectAllRow(selectedRows);
    } else if (newRow.length !== selectedRows.length) {
      if (newRow.length < selectedRows.length) {
        const deSelectedArr = selectedRows.filter(
          (obj1) =>
            !newRow.some((obj2) => obj2.scheduler_uuid === obj1.scheduler_uuid)
        );
        if (deSelectedArr.length > 0) props.onSelectRow(deSelectedArr[0], true);
        else props.onSelectRow(selectedRows[0], true);
      } else newRow.length > 0 && props.onSelectRow(newRow[0]);
    }
    setSelectedRows(event.selectedRows);
  };

  const handleSort = (column, direction) => {
    console.log(column);
    console.log(direction);
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleViewReport = (row) => {
    // const isFctw = containsFctwPattern(`${row.tag_name}`);
    const reportUrl =
      row.open_loop_type === "PR"
        ? `/PR_Report_Screen/overall?page=open_loop&execution_id=${row.execution_uuid}&test_run_id=${row.test_run_id}&reporting_level=test_run_id&scenario_group_name=${row.scenario_group_name}`
        : `/reporting?page=open_loop&execution_id=${row.execution_uuid}&test_run_id=${row.test_run_id}&reporting_level=test_run_id&scenario_group_name=${row.scenario_group_name}`;
    window.open(reportUrl, "_blank");
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const reportStatus=(row)=>{
    return axios.post(
      "/cm_open_loop/fetch_execution_report_status",
      {
        reporting_id: row.test_run_id,
        reporting_level: "test_run_id",
        reporting_type: row.open_loop_type === "PR" ? "PR" : "PG",
      }
    );
  }
  
  const viewReportPrecheck = async (row) => {
    try {
      const response = await reportStatus(row);
      if (!response.data.status || response.data.status.toLowerCase() !== "completed") {
        setDialogOpen(true);
        setDialogMessage(
          "Execution status - " + (!response.data.status
            ? "Error occurred"
            : response.data.status)
        );
        return
      }
      handleViewReport(row);
    } catch (error) {
      setDialogOpen(true);
      if (error.response && error.response.data && error.response.data.status)
        setDialogMessage("Execution status - " + error.response.data.status);
      else setDialogMessage("Execution status - Error occurred");
    }
  };

  const generateReportPrecheck = async (row) => {
    try {
      setIsLoading(true);
      const response =await reportStatus(row)
      if (response.data.status && response.data.status.toLowerCase() !== "completed") {
        setDialogOpen(true);
        setDialogMessage(
          `Report execution was in progress`);
        return
      } 
      handleGenerateReport(row);
    } catch (error) {
      setDialogOpen(true);
      if (error.response && error.response.data && error.response.data.status)
        setDialogMessage(`Report execution was in ${error.response.data.status} status`);
      else setDialogMessage("Issue occurred, please connect with your admin.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGenerateReport = async (row) => {
    const isFctw = containsFctwPattern(`${row.tag_name}`) ; 
    const awsUrl = isFctw ? process.env.REACT_APP_REPORTING_OPEN_LOOP_FCTW_LAMBDA_URL :
    process.env.REACT_APP_REPORTING_OPEN_LOOP_DECIDER_LAMBDA_URL;
    try {
      setIsLoading(true);
      const response = await axios.post(
        awsUrl,
        { ...row, reporting_level: "test_run_id" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setDialogMessage("Report generation has started successfully. Your report will be available shortly.");
    } catch (error) {
      console.error("Error generating report:", error);
      setDialogMessage("Failed to generate report.");
    } finally {
      setIsLoading(false);
      setDialogOpen(true);
    }
  };

  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post("/generate-presigned-url", {
      s3_location: filePath,
    });
    window.open(fileToDownload.data.presigned_url);
  };

  let initialColumns = [
    {
      name: "Updated At",
      selector: "updated_at",
      sortable: true,
      reorder: true,
      grow: 2,
    },
    {
      name: "Actions",
      selector: "actions",
      reorder: true,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Tooltip placement="top" title={<h6>Generate Report</h6>}>
              <IconButton
                aria-label="delete"
                onClick={() => generateReportPrecheck(row)}
                style={{ padding: "4px" }}
              >
                <PlayCircleFilledWhiteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>View Report</h6>}>
              <IconButton
                onClick={() => viewReportPrecheck(row)}
                style={{ padding: "4px" }}
              >
                <DescriptionIcon />
              </IconButton>
            </Tooltip>
            {!props.isReportingMode && <Tooltip placement="top" title={<h6>Download Report {"<TBD>"}</h6>}>
              <IconButton
                disabled={row.file_path === null || row.file_path === ''}
                aria-label="delete"
                style={{ padding: "4px" }}
                onClick={() => handleDownload(row.file_path)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>}
          </div>
        );
      },
    },
  ];

  const executionColumns = [
    {
      name: "Scenario Group",
      selector: "scenario_group_name",
      sortable: true,
      reorder: true,
      grow: 3,
      cell: (row) => {
        return <span>{row.scenario_group_name}</span>;
      },
    },

    {
      name: "Total Scenarios",
      selector: "total_scenario_count",
      sortable: true,
      reorder: true,
    },
    {
      name: "Completed",
      selector: "scenario_completed_count",
      sortable: true,
      reorder: true,
    },
    {
      name: "Updated By",
      selector: "updated_by",
      sortable: true,
      reorder: true,
      grow: 2,
    },
  ]
  const columnsForReportingMode = [
    {
      name: "Scenario UUID",
      selector: "scenario_uuid",
      sortable: true,
      reorder: true,
      cell: (row) => {
        return <span>{row.scenario_uuid}</span>;
      },
    }
  ];
  if (props.isReportingMode) initialColumns = [...columnsForReportingMode, ...initialColumns];
  else initialColumns = [...executionColumns, ...initialColumns];

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const setPreselectedRow = (res) => {
    if (props.selectedRows.length > 0) {
      const newSelectedRow = res.data.filter((item) =>
        props.selectedRows.find(
          (obj) => obj.scheduler_uuid === item.scheduler_uuid
        )
      );
      setSelectedRows(newSelectedRow);
    }
  };

  const fetchLogicalFusionData = async () => {
    setIsLoading(true);
    const response = await axios.post(
      `/cm_open_loop_pg/fetchTestRunIdsForExecution`,
      {
        execution_uuid: props.data.execution_uuid,
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        sort_field_record: sortField,
        sort_order_record: sortOrder
      }
    );

    setPreselectedRow(response.data);
    setScenarioCollectionNew(response.data.data);
    setTotal(response.data["total_records"]);
    setIsLoading(false);
  };

  const fetchReportingModeFuctionData = async () => {
    console.log('props.data.cad_uuid', props.data.cad_uuid);
    
    setIsLoading(true);
    const response = await axios.post(
      props.type === "pg" ? "/cm/reporting-mode/cad-nested-execution-pg" : "yet_to_be_decided",
      {
        cad_uuid: props.data.cad_uuid,
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
      }
    );
    console.log("response", response);
    setScenarioCollectionNew(response.data.data);    
    setTotal(response.data["total_records"]);
    setIsLoading(false);
  }

  useEffect(() => {
    setColumns(initialColumns);
    if (props.isReportingMode) fetchReportingModeFuctionData();
    else fetchLogicalFusionData();
  }, [eventsPerPage, page,sortOrder,sortField]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [props.cartItems]);

  useEffect(() => {
    props.allSelect && props.updateCart(scenarioCollectionNew, "add", true);
  }, [props.allSelect]);

  const handleAddToCart = useCallback((scenario) => {
    props.updateCart(scenario, "add");
  }, []);

  return (
    <div
      style={{
        padding: "1rem",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
        }}
      >
        <CustomPagination
          fromTestLevelReportingMode={true}
          total={total}
          rowsPerPageOptions={rowsPerPageSessionBased}
          eventsPerPage={eventsPerPage}
          page={page}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onPageChange={handlePageChange}
        />
        {columns.length > 0 ? (
          <DataTable
            selectableRows
            selectableRowDisabled={(row) => row.file_path === null || row.file_path === '' || props.isReportingMode}
            onSelectedRowsChange={handleChange}
            onSort={handleSort}
            sortServer
            selectableRowSelected={(row) =>
              selectedRows.some((obj) =>
                Object.keys(obj).some((key) => obj[key] === row.scheduler_uuid)
              )
            }
            clearSelectedRows={props.clearRows}
            columns={columns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
          ></DataTable>
        ) : null}
      </div>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">API Response</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default TestRunsListing;
